import { render, staticRenderFns } from "./new-pickup-point.vue?vue&type=template&id=25a91fba"
import script from "./new-pickup-point.js?vue&type=script&lang=js&external"
export * from "./new-pickup-point.js?vue&type=script&lang=js&external"
import style0 from "./new-pickup-point.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports